import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { baseUrl } from "../utils/utils";

// Async thunk to get paginated bank reports
export const get_bank_reports = createAsyncThunk("bankReports/get", async (data) => {
  const body = new FormData();
  body.append("action", "list");
  
  // Only append if values exist to avoid sending undefined/null
  if (data.fd) body.append("fd", data.fd); // from date
  if (data.td) body.append("td", data.td); // to date
  if (data.page) body.append("page", data.page);
  if (data.limit) body.append("limit", data.limit);
  if (data.bank_id) body.append("bank_id", data.bank_id);

  const response = await fetch(baseUrl + "reports/bank_report.php", {
    method: "POST",
    body: body,
  });

  const res = await response.json();
  console.log("Bank Reports Response =>", res);
  return res;
});

const initialState = {
  bank_reports: [],
  loading: false,
  total_count: 0,
  count: 0, // Add this for current page count
};

const bankReportSlice = createSlice({
  name: "bankReports",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(get_bank_reports.pending, (state) => {
        state.loading = true;
      })
      .addCase(get_bank_reports.rejected, (state) => {
        state.loading = false;
        // Reset data on error
        state.bank_reports = [];
        state.total_count = 0;
        state.count = 0;
      })
      .addCase(get_bank_reports.fulfilled, (state, action) => {
        state.loading = false;
        const data = action.payload;
        if (data.success) {
          state.bank_reports = data.list || [];
          state.total_count = parseInt(data.totalcount) || 0;
          state.count = parseInt(data.count) || 0; // Store current page count
        } else {
          state.bank_reports = [];
          state.total_count = 0;
          state.count = 0;
        }
      });
  },
});

export default bankReportSlice.reducer;